let cartRecInjected = false;

function injectCartRecommendations() {
  const dialog = document.querySelector('cart-drawer-component dialog');
  if (!dialog) return;
  if (cartRecInjected || dialog.querySelector('.missoma-upsell-column')) return;

  // 正确容器：cart-drawer__inner
  const inner = dialog.querySelector('.cart-drawer__inner');
  if (!inner) { console.warn('未找到 cart-drawer__inner'); return; }

  // 创建左侧推荐列
  const leftCol = document.createElement('div');
  leftCol.className = 'missoma-upsell-column';
  leftCol.innerHTML = `
    <p class="missoma-upsell-title">WHY NOT ADD</p>
    <div class="missoma-upsell-list">加载中...</div>
  `;

  // 把 inner 变成 flex 两栏：左边推荐，右边原有内容
  inner.style.cssText = 'display:flex !important; flex-direction:row; height:100%; overflow:hidden;';

  // 左栏插到 inner 最前面
  inner.insertBefore(leftCol, inner.firstChild);

  // 注入样式
  if (!document.getElementById('missoma-cart-style')) {
    const st = document.createElement('style');
    st.id = 'missoma-cart-style';
    st.textContent = `
      .missoma-upsell-column {
        width: 220px;
        min-width: 220px;
        flex-shrink: 0;
        overflow-y: auto;
        padding: 20px 16px;
        border-right: 1px solid #e8e0d8;
        box-sizing: border-box;
      }
      .missoma-upsell-title {
        font-size: 11px;
        font-weight: 400;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #888;
        margin: 0 0 16px 0;
      }
      .missoma-upsell-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
      .missoma-upsell-item {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .missoma-upsell-item a {
        display: block;
        width: 100%;
      }
      .missoma-upsell-item img {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        display: block;
        background: #f7f7f7;
      }
      .missoma-upsell-item-title {
        font-size: 13px;
        margin: 0;
        line-height: 1.4;
        color: #111;
      }
      .missoma-upsell-item-price {
        font-size: 13px;
        color: #111;
        margin: 0;
      }
      .missoma-upsell-add-btn {
        width: 100%;
        border: 1px solid #000;
        background: #fff;
        color: #000;
        border-radius: 999px;
        padding: 9px 12px;
        font-size: 12px;
        cursor: pointer;
        box-sizing: border-box;
        transition: 0.2s ease;
      }
      .missoma-upsell-add-btn:hover {
        background: #000;
        color: #fff;
      }
      @media (max-width: 860px) {
        .cart-drawer__inner {
          flex-direction: column !important;
        }
        .missoma-upsell-column {
          width: 100%;
          min-width: unset;
          max-height: 40vh;
          border-right: none;
          border-bottom: 1px solid #e8e0d8;
        }
      }
    `;
    document.head.appendChild(st);
  }

  cartRecInjected = true;

  fetch('/products.json?limit=5')
    .then(r => r.json())
    .then(d => renderUpsell(leftCol.querySelector('.missoma-upsell-list'), d.products))
    .catch(() => { leftCol.remove(); });
}

function renderUpsell(container, products) {
  if (!products || !products.length) { container.innerHTML = ''; return; }
  const valid = products.filter(p => p.variants?.[0]);
  container.innerHTML = valid.slice(0, 4).map(p => {
    const v = p.variants[0];
    return `
      <div class="missoma-upsell-item">
        <a href="/products/${p.handle}">
          <img src="${p.images?.[0]?.src || ''}" alt="${p.title}" loading="lazy">
        </a>
        <p class="missoma-upsell-item-title">${p.title}</p>
        <p class="missoma-upsell-item-price">$${(v.price / 100).toFixed(2)}</p>
        <button class="missoma-upsell-add-btn" data-variant-id="${v.id}">Add to Bag</button>
      </div>
    `;
  }).join('');

  container.querySelectorAll('.missoma-upsell-add-btn').forEach(btn => {
    btn.onclick = async function (e) {
      e.preventDefault();
      this.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.dataset.variantId, quantity: 1 })
        });
        this.textContent = res.ok ? '✓ Added' : 'Add to Bag';
        if (res.ok) setTimeout(() => { this.textContent = 'Add to Bag'; }, 2000);
      } catch { this.textContent = 'Add to Bag'; }
    };
  });
}

document.addEventListener('DOMContentLoaded', () => {
 const ob = new MutationObserver(() => {
  const dialog = document.querySelector('cart-drawer-component dialog');
  if (!dialog) return;
  if (dialog.hasAttribute('open')) {
    // 每次 DOM 变化都检查，如果推荐区块消失了就重新注入
    if (!dialog.querySelector('.missoma-upsell-column')) {
      cartRecInjected = false;
      setTimeout(injectCartRecommendations, 300);
    }
  } else {
    cartRecInjected = false;
    dialog.querySelector('.missoma-upsell-column')?.remove();
    const inner = dialog.querySelector('.cart-drawer__inner');
    if (inner) inner.style.cssText = '';
  }
});
ob.observe(document.body, { subtree: true, attributes: true, childList: true, attributeFilter: ['open'] });
});
